import { render, staticRenderFns } from "./FloorPlanCanvas.vue?vue&type=template&id=633cfb0a&scoped=true&"
import script from "./FloorPlanCanvas.vue?vue&type=script&lang=js&"
export * from "./FloorPlanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FloorPlanCanvas.vue?vue&type=style&index=0&id=633cfb0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cfb0a",
  null
  
)

/* custom blocks */
import block0 from "./FloorPlanCanvas.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633cfb0a')) {
      api.createRecord('633cfb0a', component.options)
    } else {
      api.reload('633cfb0a', component.options)
    }
    module.hot.accept("./FloorPlanCanvas.vue?vue&type=template&id=633cfb0a&scoped=true&", function () {
      api.rerender('633cfb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceFloorPlans/FloorPlanCanvas.vue"
export default component.exports